"use client";

import { useParams, useRouter } from "next/navigation";
import { useEffect } from "react";

import { useAppContext } from "../../context";
import { getSession, signOut, fetchSubscriptions } from "../../actions";

export function AuthHydrator({ children }: { children: React.ReactNode }) {
  const { setUserInfo, setAuth, setOnLogout, setSubscriptionsInfo } =
    useAppContext();
  const router = useRouter();
  const params = useParams<{ locale: string }>();

  useEffect(() => {
    async function hydrate() {
      const [session, subscriptions] = await Promise.all([
        getSession(),
        fetchSubscriptions().catch(() => null),
      ]);

      if (session.isAuthenticated && session.user) {
        setUserInfo(session.user);
        setAuth({ isAuthenticated: true, isLoading: false });
        if (subscriptions) setSubscriptionsInfo(subscriptions);
      } else {
        setAuth({ isAuthenticated: false, isLoading: false });
        router.replace(`/${params.locale}/login`);
      }
    }
    hydrate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setOnLogout(() => {
      signOut().then(() => {
        setAuth({ isAuthenticated: false, isLoading: false });
        setUserInfo({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          phoneCountryCode: "",
          documentId: "",
          passportId: "",
          avatarId: "",
        });
        router.replace(`/${params.locale}/login`);
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.locale]);

  return <>{children}</>;
}
